import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

import { db } from '../../config/firebase';

import Button from '../UI/button/Button';

import './index.css';

const index = ({title, btnLink="/", type}) => {

    const [ imageDataArray, setImageDataArray ] = useState([]);
    const [ graphicsDataArray, setGraphicsDataArray ] = useState([]);

    useEffect(() => {
        db.collection('images').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
          setImageDataArray(snapshot.docs.map(doc => ({id: doc.id, data: doc.data()})));
        })
    }, []);

    useEffect(() => {
        db.collection('graphics').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
          setGraphicsDataArray(snapshot.docs.map(doc => ({id: doc.id, data: doc.data()})));
        })
    }, []);

    let dataArray = [];

    if(type === 'image'){
        dataArray = imageDataArray;
    } else if (type === 'graphics'){
        dataArray = graphicsDataArray;
    } else;

    let limit = window.innerWidth >= 481 ? 4 : 2;

    return (
        <div className="layout container">
            <p className="layout-title">{title}</p>
            <div className="layout-imageBox">
                <div className="row layout-row">
                    {
                        dataArray.slice(0,limit).map(({id, data}) => (
                            <React.Fragment>
                                <div className="col-lg-6 col-sm-12 layout-imageCol" key={id}>
                                    <img className="layout-image" src={data.image} alt={data.caption} />
                                </div>
                            </React.Fragment>
                        )) 
                    }
                </div>
            </div>
            <div className="layout-btn"><a href={btnLink}><Button>View More</Button></a></div>
            {/* <div className="layout-btn"><a href={btnLink}><Button>View More</Button></a></div> */}
        </div>
    );
};

export default index;


// WEBPACK FOOTER //
// ./src/components/imageAndGraphics/index.js